"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const UsersTable_1 = __importDefault(require("./UsersTable"));
const TableFilters_1 = require("./TableFilters");
const WidgetChangePermission_1 = __importDefault(require("./WidgetChangePermission"));
const WidgetSetAdmin_1 = __importDefault(require("./WidgetSetAdmin"));
const UsersComponent = () => {
    const { t } = (0, react_i18next_1.useTranslation)('admin');
    // We'll start our table without any data
    const [data, setData] = react_1.default.useState([]);
    const [roles, setRoles] = react_1.default.useState([]);
    const [loading, setLoading] = react_1.default.useState(false);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [pageCount, setPageCount] = react_1.default.useState(0);
    const fetchIdRef = react_1.default.useRef(0);
    // Function to fetch data from the server, with paging and filtering
    const fetchData = react_1.default.useCallback((_a) => __awaiter(void 0, [_a], void 0, function* ({ pageSize, pageIndex, filters }) {
        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current;
        // Set the loading state
        setLoading(true);
        // Make a query string from the filters
        const additionalQueryString = !filters
            ? undefined
            : filters.map((obj) => `${encodeURI(obj.id)}=${encodeURI(obj.value)}`).join('&');
        try {
            const response = yield fetch(`/api/admin/usersList?pageSize=${pageSize}&pageIndex=${pageIndex}${additionalQueryString ? `&${additionalQueryString}` : ''}`);
            if (fetchId !== fetchIdRef.current) {
                // There was another query since, ignore
                return;
            }
            if (response.status === 200) {
                const jsonData = yield response.json();
                if (jsonData.users) {
                    setData(jsonData.users);
                }
                if (jsonData.totalCount) {
                    setTotalCount(jsonData.totalCount);
                    setPageCount(Math.ceil(jsonData.totalCount / pageSize));
                }
                if (jsonData.roles) {
                    setRoles(jsonData.roles);
                }
            }
            else {
                console.error('Invalid response code from server: ', response.status);
            }
        }
        catch (error) {
            console.error(`Error fetching user data from server: ${error}`);
            setData([]);
            setTotalCount(0);
        }
        finally {
            if (fetchId === fetchIdRef.current) {
                setLoading(false);
            }
        }
    }), []);
    // Columns of the user table
    // TODO This may be where we add column formatting
    const columns = react_1.default.useMemo(() => {
        const columns = [
            {
                Header: t('admin:user:Username'),
                accessor: 'username',
                Filter: TableFilters_1.DefaultColumnFilter
            },
            {
                Header: t('admin:user:Email'),
                accessor: 'email',
                Filter: TableFilters_1.DefaultColumnFilter
            },
            {
                Header: t('admin:user:isAdmin'),
                accessor: 'is_admin',
                Cell: (cellProps) => (react_1.default.createElement(WidgetSetAdmin_1.default, { isAdmin: cellProps.value, userUuid: cellProps.row.original.uuid, userId: cellProps.row.original.id }))
            }
        ];
        if (roles.length > 0) {
            columns.push({
                Header: t('admin:user:roles'),
                accessor: 'permissions',
                Cell: (cellProps) => (react_1.default.createElement(WidgetChangePermission_1.default, { roles: roles, currentValues: cellProps.value, userUuid: cellProps.row.original.uuid }))
            });
        }
        return columns;
    }, [t, roles]);
    return (react_1.default.createElement("div", { className: "admin" },
        react_1.default.createElement(UsersTable_1.default, { columns: columns, data: data, fetchData: fetchData, loading: loading, pageCount: pageCount, itemCount: totalCount })));
};
exports.default = UsersComponent;
//# sourceMappingURL=UsersComponent.js.map